<template>
  <section
    class="component-aeb26ed5"
    resmed-component-name="product_ratings_and_reviews"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="text-center">
          <eyebrow-icon
            v-if="acf.eyebrowicon"
            v-bind:eyebrowicon="acf.eyebrowicon"
            v-bind:align="'center'"
          ></eyebrow-icon>
          <h5>Ratings and reviews</h5>
          <h2>What people are saying about {{ acf.product.name }}</h2>
        </div>
        <header>
          <div class="results">
            {{ $getTranslation("Displaying", $route.params.region) }}: {{ displaying }} of
            <strong>{{ acf.reviews.length }}</strong> {{ $getTranslation("results", $route.params.region) }}
          </div>

          <div
            class="order-md-1 sort"
            v-bind:class="{ 'is-active': sort.active }"
            v-on:mouseleave="sort.active = false"
          >
            <span v-on:click="sort.active = !sort.active"
              >{{ sort.label }}{{ sort.append }}</span
            >
            <ul v-if="sort.active">
              <li
                v-for="item in [
                  'Newest',
                  'Highest to Lowest',
                  'Lowest to Highest',
                ]"
                v-bind:class="{ 'is-active': sort.applied === item }"
              >
                <a
                  v-on:click.prevent="
                    (sort.applied = item) && (sort.active = false)
                  "
                  href="#"
                  >{{ item }}</a
                >
              </li>
            </ul>
          </div>
          <a
            href="reviews/"
            class="
              btn
              cta-plain
              text-red
              icon
              right-arrow
              mr-3
              mt-2 mt-md-0
              write-review
            "
            >Write a review</a
          >
        </header>
        <div class="reviews">
          <div
            class="row item"
            v-for="item in page.content"
            v-bind:post-id="item.ID"
          >
            <div class="col-md-4 col-lg-3">
              <div class="review-rating">
                <span v-bind:rating="item.acf['star-rating']"></span>
              </div>
              <div class="review-date">
                {{ item.acf["activity-date"] | fromNow() }}
              </div>
              <div class="review-name">{{ item.acf.name || "Anonymous" }}</div>
              <div class="review-state" v-if="item.acf.state">
                {{ item.acf.state }}
              </div>
            </div>
            <div class="col-md-8 col-lg-9">
              <p class="mt-1 mt-md-0">{{ item.post_content }}</p>
              <div
                class="replacement-frequency"
                v-if="
                  item.acf['replacement-frequency'] &&
                  acf.product.type === 'mask'
                "
              >
                I replace my mask cushion:
                {{ item.acf["replacement-frequency"] }}
              </div>
            </div>
          </div>
        </div>

        <paginate
          v-if="reviews.length > 1"
          v-model="page.number"
          :page-count="reviews.length"
          :page-range="7"
          :click-handler="
            () => {
              scroll({ to: $el });
            }
          "
          :prev-text="`<button type='button' class='btn navigation-icon left-caret-alt slick-slider-button-prev'></button>`"
          :next-text="`<button type='button' class='btn navigation-icon right-caret-alt slick-slider-button-next'></button>`"
          container-class="pagination mt-5"
        >
        </paginate>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import paginate from "vuejs-paginate";
import { scroll } from "../../mixins/index";

export default {
  name: "component-aeb26ed5", // product_ratings_and_reviews
  props: ["acf"],
  components: {
    paginate,
  },
  mixins: [scroll],
  data() {
    return {
      reviews: [],
      sort: {
        active: false,
        label: "Sort by",
        applied: "Newest",
        append: "",
      },
      page: {
        size: 10,
        number: 0,
        content: [],
      },
    };
  },
  computed: {
    displaying() {
      let a = this.page.size * this.page.number + 1,
        b = a - this.page.size;

      if (this.reviews.length === this.page.number) {
        return `${b} - ${this.acf.reviews.length}`; // last page
      }

      return `${b} - ${this.page.number * this.page.size}`;
    },
  },
  watch: {
    "sort.applied": {
      handler(val) {
        let reviews = [];

        if (val === "Newest") {
          reviews = this.acf.reviews.sort((a, b) => {
            return b.acf.timestamp - a.acf.timestamp;
          });
        }
        if (val === "Highest to Lowest") {
          reviews = this.acf.reviews.sort((a, b) => {
            return b.acf["star-rating"] - a.acf["star-rating"];
          });
        }
        if (val === "Lowest to Highest") {
          reviews = this.acf.reviews.sort((a, b) => {
            return a.acf["star-rating"] - b.acf["star-rating"];
          });
        }

        let clone = reviews.slice(0);
        this.reviews = this.chunks(clone, this.page.size);

        // reset page number
        this.page.number = 0;
        this.$nextTick(() => {
          this.page.number = 1;
        });
      },
      immediate: true,
    },
    "page.number": {
      handler(val) {
        this.page.content = this.reviews[val - 1];
      },
      immediate: true,
    },
  },
  filters: {
    format(date) {
      return moment(date).format("D.M.YYYY");
    },
    fromNow(date) {
      return moment(date).fromNow();
    },
  },
  methods: {
    chunks(array, size) {
      let results = [];

      while (array.length) {
        results.push(array.splice(0, size));
      }
      return results;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-aeb26ed5 {
  padding: 6rem 0 5rem 0;
}

.component {
  h5 {
    position: relative;
    margin: 0 0 0.5rem 0;

    @extend %eyebrow-center;
  }

  header {
    padding: 0.5rem 0;
    margin-bottom: 2rem;
    border-top: 1px solid rgba($cc-resmed-grey-30, 0.75);
    border-bottom: 1px solid rgba($cc-resmed-grey-30, 0.75);

    @media (min-width: 768px) {
      height: 62px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
    }

    .results {
      flex-grow: 1;
    }

    .write-review {
      flex-grow: 0;
    }

    .sort {
      z-index: 1;
      align-self: flex-start;
      position: relative;
      background-color: #eaeff6;
      background-position: calc(100% - 1.25rem) 1rem;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/form-dropdown-caret.svg);
      background-size: 0.675rem 0.675rem;
      border-radius: 6px;
      @extend %body-small;
      color: rgba($cc-resmed-black, 0.75);

      @media (max-width: 767px) {
        margin: 1rem auto 0.625rem auto;
      }

      &.is-active {
        color: rgba($cc-resmed-black, 0.325);
        background-image: url(#{$assets}/images/form-dropdown-caret-up.svg);
      }

      span {
        @extend %body-small-bold;
        display: block;
        padding: 0.75rem 1.5rem;
        border-radius: 6px;
        cursor: pointer;
        height: auto;

        @media (min-width: 768px) {
          width: 170px;
        }
      }

      ul {
        display: absolute;
        list-style: none;

        padding: 0.25rem 1rem 0.75rem 1rem;

        li {
          margin-bottom: 0.5rem;

          &:last-child {
            margin-bottom: 0;
          }

          &.is-active {
            a {
              @extend %body-small-bold;
              cursor: default;
            }
          }

          a {
            color: rgba($cc-resmed-black, 0.75);
            display: block;
          }
        }
      }
    }
  }

  .reviews {
    .item {
      margin-top: 0.875rem 0;
      margin-bottom: 0.875rem 0;
      padding: 0.875rem 0;

      .review-rating {
        display: flex;
        margin-bottom: 0.5rem;

        span {
          display: block;
          width: 120px;
          height: 20px;
          margin-right: 0.625rem;
          transition: all 0.5s;

          background-image: url(#{$assets}/images/star-ratings-blue-0.svg);
          background-position: left center;
          background-repeat: no-repeat;
          background-size: 120px;

          @for $i from 0 through 5 {
            &[rating="#{$i}"] {
              background-image: url(#{$assets}/images/star-ratings-blue-#{$i}.svg);
            }
          }
        }
      }

      .review-date {
        @extend %body-small-bold;
        margin-bottom: 0.75rem;
      }

      .review-name {
        font-size: 1.125rem;
        font-family: "Plus Jakarta Sans", sans-serif;
        font-weight: 700;
      }

      .review-state {
        @extend %body-small-bold;
      }

      .replacement-frequency {
        padding-left: 1.625rem;
        background-position: left center;
        background-size: 18px 18px;
        background-repeat: no-repeat;
        background-image: url(#{$assets}/images/icon-mask-frequency.svg);
      }
    }
  }
}
</style>

<style lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-aeb26ed5 {
  .pagination {
    padding: 0.5rem 0;
    margin-bottom: 2rem;
    border-top: 1px solid rgba($cc-resmed-grey-30, 0.75);
    border-bottom: 1px solid rgba($cc-resmed-grey-30, 0.75);

    list-style-type: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 -0.5rem;

    li {
      &:first-child {
        margin-right: 2rem;

        a {
          margin-left: 0;
        }
      }

      &:last-child {
        margin-left: 2rem;
      }

      a {
        color: $cc-resmed-black;
        display: block;
        padding: 0.5rem;
        font-family: "Plus Jakarta Sans", sans-serif;
        font-weight: 700;

        &:not(:disabled):not(.disabled) {
          cursor: pointer;
        }
      }

      &:hover,
      &.active {
        a {
          z-index: 1;
          color: $cc-resmed-grey-30;
        }
      }

      &.disabled {
        a {
          pointer-events: none;
          cursor: auto;

          * {
            filter: grayscale(100%);
          }
        }
      }
    }
  }
}
</style>